import { Component, OnInit, ChangeDetectorRef, ElementRef, Output, EventEmitter, OnDestroy } from '@angular/core';
import { EOSService } from '@app/cp/shared/services/eos.service';
import { KPIParameter } from '@app/cp/shared/models/KPIParameter';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { v_UserScorecardsBus } from '@app/cp/shared/models/v_UserScorecardsBus';
import { ScorecardResult } from '@app/cp/shared/models/ScorecardResult';
import { v_UserKPIsBus } from '@app/cp/shared/models/v_UserKPIsBus';
import { v_KPIsBus } from '@app/cp/shared/models/v_KPIsBus';
import { v_KPIParameterHistoryBus } from '@app/cp/shared/models/v_KPIParameterHistoryBus';
import { Subscription } from 'rxjs';
import { CmProAuthService } from '@app/core/services';
import { UsersBus } from '@app/cp/shared/models/UsersBus.model';

@Component({
    selector: 'cp-kpiwidget',
    templateUrl: './kpiwidget.component.html',
    styleUrls: ['./kpiwidget.component.scss']
})
export class KpiwidgetComponent implements OnInit, OnDestroy {

    userId: any;
    personId: any;
    companyId: any;
    dataRef: v_UserScorecardsBus[];
    dataKPI: v_KPIsBus[];
    dataKPIDef: v_UserKPIsBus[];
    dataResultView: ScorecardResult[] = [];
    dataKPIHist: v_KPIParameterHistoryBus[];

    kpiParam: KPIParameter;
    svc_data_subs: Subscription;
    svc_scorecard_subs: Subscription;
    svc_data_kpi_def: Subscription;
    svc_data_kpi_hist: Subscription;

    @Output() loaderState = new EventEmitter<any>();
    @Output() loaderErrorState = new EventEmitter<any>();

    constructor(private svc_data: EOSService, globals: GlobalsService, private cd: ChangeDetectorRef, private authService: CmProAuthService, private el: ElementRef) {

    }

    ngOnDestroy(): void {
        this.authService.unsubscribeToLoginEvents();
    }

    ngOnInit() {

        this.authService.subscribeToLoginEvents((user: UsersBus) => {
            if (user) {
                this.userId = user.userid;
                this.personId = user.personId;
                this.companyId = user.companyId;

                this.buildKPIs('');
                //this retrieves the scorecard(s) the user has access to
                this.svc_scorecard_subs = this.svc_data.getUserScorecards(this.userId).subscribe(data => {
                    this.dataRef = data;
                    var scoreItem = new v_UserScorecardsBus();
                    scoreItem.featureName = "All My Kpi's";
                    this.dataRef.push(scoreItem);
                });
            }
        });
    }

    showSpinner() {
        this.loaderState.emit(true);
        $(this.el.nativeElement).closest('.cp-widget').find('.jarviswidget-loader').first().css('display', 'block');
    }

    hideSpinner() {
        this.loaderState.emit(false);
        $(this.el.nativeElement).closest('.cp-widget').find('.jarviswidget-loader').css('display', 'none');
    }

    selectScorecard(dataProp: v_UserScorecardsBus) {
        var y = document.getElementsByClassName('btn  btn-xs btn-warning');
        y[0].innerHTML = dataProp.featureName + ' <i class="fa fa-caret-down">';
        this.buildKPIs(dataProp.featureId);
    }

    buildKPIs(featureId) {

        this.showSpinner();
        this.kpiParam = new KPIParameter();
        //todo need to find out why personid wouldn't pass correctly in set paramaters
        this.kpiParam.setParameters(this.userId, this.whatisSaturday(), this.companyId);
        this.kpiParam.personId = this.personId;

        //start call to get all of the user kpis
        this.svc_data_kpi_def = this.svc_data.getUserKPIs(this.userId).subscribe(data => {

            if (featureId) {
                this.dataKPIDef = data.filter(function (obj) {
                    return (obj.featureId === featureId);
                });
            }
            else {
                this.dataKPIDef = data;
            }

            //once we have all of the users kpis, make call to get all kpi results
            this.svc_data_subs = this.svc_data.getAllUserKPIs(this.kpiParam).subscribe(data => {
                this.dataKPI = data;

                var startDate = new Date(this.whatisYearHistory().getTime() - (this.whatisYearHistory().getTimezoneOffset() * 60000))
                    .toISOString()
                    .split("T")[0];

                var endDate = new Date(this.whatisSaturday().getTime() - (this.whatisSaturday().getTimezoneOffset() * 60000))
                    .toISOString()
                    .split("T")[0];

                this.svc_data_kpi_hist = this.svc_data.getUserKPIParameterHistory(this.userId, this.whatis6MonthHistory(), this.whatisSaturday()).subscribe(data => {
                    this.dataKPIHist = data;

                    this.buildResultView();
                    this.cd.detectChanges();
                    this.initSparkline();

                });
            });
        });
    }

    buildResultView() {

        this.dataResultView = [];
        for (let entry of this.dataKPIDef) {

            let pushObj = new ScorecardResult();
            pushObj.measurable = entry.paramaterName;
            pushObj.kpiParameterId = entry.kpiParamaterId;
            if (entry.thresholdDirection == 'Greater Than') {
                pushObj.goal = entry.goalValue.toString();
				pushObj.goalSymbol = "fa-greater-than";
			}
            else if (entry.thresholdDirection == 'Greater Than Equal To') {
                pushObj.goal = entry.goalValue.toString();
				pushObj.goalSymbol = "fa-greater-than-equal";
			}
            else if (entry.thresholdDirection == 'Lower Than') {
                pushObj.goal = entry.goalValue.toString();
				pushObj.goalSymbol = "fa-less-than";
			}
            else if (entry.thresholdDirection == 'Lower Than Equal To') {
                pushObj.goal = entry.goalValue.toString();
				pushObj.goalSymbol = "fa-less-than-equal";
			}
            else if (entry.thresholdDirection == 'Equal To') {
                pushObj.goal = entry.goalValue.toString();
				pushObj.goalSymbol = "fa-equals";
			}

            pushObj.impvalue = entry.improvmentValue;

            for (let kpiData of this.dataKPI) {
                if (kpiData.kpiParamaterId == entry.kpiParamaterId) {
                    var startTrend1 = [];
                    var goalTrend1 = [];
                    var minValue = 0;
                    var maxValue = 0;

                    //figure out trend history
                    for (let kpiTrend of this.dataKPIHist) {

                        if (kpiTrend.kpiParamaterId == entry.kpiParamaterId) {
                            if (kpiTrend.trendValue < minValue)
                                minValue = kpiTrend.trendValue;
                            if (kpiTrend.trendValue > maxValue)
                                maxValue = kpiTrend.trendValue;

                            startTrend1.push(kpiTrend.trendValue);

                            goalTrend1.push(kpiTrend.currentGoalValue);
                        }
                    }
                    var minSpark = (minValue - 10);
                    var maxSpark = (maxValue + 10);

                    pushObj.sparklinevalmax = maxSpark;
                    pushObj.sparklinevalmin = minSpark;
                    pushObj.sparklineval1 = startTrend1;
                    pushObj.sparklineval2 = goalTrend1;

                    if (entry.thresholdType == 'Percentage') {
                        //calculate out if you reached your goal or not
                        pushObj.value = kpiData.ratioValue + '%';
                    }
                    else if (entry.thresholdType == 'Dollar') {
                        pushObj.value = '$' + kpiData.dollarValue;
                    }
                    else if (entry.thresholdType == 'Integer') {
                        pushObj.value = kpiData.intValue1;
                    }
                    else if (entry.thresholdType == 'Decimal') {
                        pushObj.value = kpiData.ratioValue;
                    }

                    //now that you have the value need to determine if met goals
                    if (entry.thresholdDirection == 'Greater Than') {
                        // need to compare the ratio result and see if its greater than the goal
                        if (pushObj.value > entry.goalValue)
                            pushObj.goalicon = "fa-caret-up green";
                        else if (pushObj.value >= entry.improvmentValue)
                            pushObj.goalicon = "fa-minus yellow";
                        else
                            pushObj.goalicon = "fa-caret-down red";
                    }
                    else if (entry.thresholdDirection == 'Greater Than Equal To') {
                        // need to compare the ratio result and see if its greater than equal the goal
                        if (pushObj.value >= entry.goalValue)
                            pushObj.goalicon = "fa-caret-up green";
                        else if (pushObj.value >= entry.improvmentValue)
                            pushObj.goalicon = "fa-minus yellow";
                        else
                            pushObj.goalicon = "fa-caret-down red";
                    }
                    else if (entry.thresholdDirection == 'Lower Than') {
                        // need to compare the ratio result and see if its lower then the goal
                        if (pushObj.value < entry.goalValue)
                            pushObj.goalicon = "fa-caret-up green";
                        else if (pushObj.value <= entry.improvmentValue)
                            pushObj.goalicon = "fa-minus yellow";
                        else
                            pushObj.goalicon = "fa-caret-down red";
                    }
                    else if (entry.thresholdDirection == 'Lower Than Equal To') {
                        // need to compare the ratio result and see if its lower then equal the goal
                        if (pushObj.value <= entry.goalValue)
                            pushObj.goalicon = "fa-caret-up green";
                        else if (pushObj.value <= entry.improvmentValue)
                            pushObj.goalicon = "fa-minus yellow";
                        else
                            pushObj.goalicon = "fa-caret-down red";
                    }
                    else if (entry.thresholdDirection == 'Equal To') {
                        // need to compare the ratio result and see if its equal to
                        if (pushObj.value == entry.goalValue)
                            pushObj.goalicon = "fa-caret-up green";
                        else
                            pushObj.goalicon = "fa-caret-down red";
                    }
                    break;
                }
            }
            this.dataResultView.push(pushObj);
        }
        this.hideSpinner();

        if (this.dataKPIDef.length == 0)
            $(this.el.nativeElement).find('.kpino-results').css("display", "block");
        else
            $(this.el.nativeElement).find('.kpino-results').css("display", "none");
    }

    whatisSaturday() {
        //get this current saturday and then take back a couple days
        var saturday = this.getLastWeekday(new Date(), 6);
        var d = new Date(saturday);
        d.setDate(d.getDate() - 7);
        return new Date(d.toDateString());
    }
    whatisYearHistory() {
        //get this current saturday and then take back a couple days
        var saturday = this.getLastWeekday(new Date(), 6);
        var d = new Date(saturday);
        d.setDate(d.getDate() - 365);
        return new Date(d.toDateString());
    }
    whatis3MonthHistory() {
        //get this current saturday and then take back a couple days
        var saturday = this.getLastWeekday(new Date(), 6);
        var d = new Date(saturday);
        d.setDate(d.getDate() - 90);
        return new Date(d.toDateString());
    }
    whatis6MonthHistory() {
        //get this current saturday and then take back a couple days
        var saturday = this.getLastWeekday(new Date(), 6);
        var d = new Date(saturday);
        d.setDate(d.getDate() - 120);
        return new Date(d.toDateString());
    }
    getLastWeekday(date, weekday) { // 0 = sunday, 1 = monday, ... , 6 = saturday
        var d = new Date(date);
        d.setDate(d.getDate() + weekday - d.getDay()); // move to last of given weekday
        return d;
    }

    viewDetails(dataProp: ScorecardResult) {
        var endDate = new Date(this.whatisSaturday().getTime() - (this.whatisSaturday().getTimezoneOffset() * 60000))
            .toISOString()
            .split("T")[0];

        var srcVal = 'http://www.fieldgetics.com/eos/viewdetail.aspx?kpiId=' + dataProp.kpiParameterId + '&startdate=' + endDate + '&state=ALL';
        window.open(srcVal, '_blank');
    }

    openKPIDetail(dataProp: ScorecardResult) {
        var srcVal = 'http://www.fieldgetics.com/eos/viewtrend.aspx?p=' + this.personId + '&k=' + dataProp.kpiParameterId;
        window.open(srcVal, '_blank');
    }

    initSparkline() {
        //render composit sparkline for grid
        //Below Commented out during Angular 9 Upgrade because of JQuery issue
        //$(this.el.nativeElement).find('.mysparkline').sparkline('html',
        //    {
        //        enableTagOptions: true,
        //        type: 'bar',
        //        tagValuesAttribute: 'barvalues',
        //        height: '40px',
        //        barColor: '#6A80A9',
        //        barWidth: 5,
        //        barSpacing: 2,
        //        chartRangeMin: 'sparkChartRangeMin',
        //        chartRangeMax: 'sparkChartRangeMax',
        //        disableInteraction: false
        //    }
        //);
        //$(this.el.nativeElement).find('.mysparkline').sparkline('html',
        //    {
        //        composite: true,
        //        enableTagOptions: true,
        //        type: 'line',
        //        tagValuesAttribute: 'linevalues',
        //        height: '40px',
        //        lineWidth: 1,
        //        lineColor: '#02A570',
		//		fillColor: '#000000',
        //        spotRadius: 2,
        //        spotColor: true,
        //        minSpotColor: '#18DC9C',
        //        maxSpotColor: '#48ebb6',
        //        chartRangeMin: 'sparkChartRangeMin',
        //        chartRangeMax: 'sparkChartRangeMax',
        //        disableInteraction: false
        //    }
        //);
    }
}
